"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrositeConfigKeys = void 0;
exports.MicrositeConfigKeys = {
    __typename: true,
    id: true,
    slug: true,
    password: false,
    name: true,
    description: true,
    color: true,
    fontColor: true,
    logoUrl: false,
    header: false,
    reportPeriods: true,
    standards: true,
    organizationID: true,
    language: true,
    lastReleasedAt: false,
};
//# sourceMappingURL=MicrositeConfig.type.js.map